
import React from 'react';
import * as api from '../../../../../api';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import 'font-awesome/css/font-awesome.min.css'
import { Icon } from 'semantic-ui-react'

class UserFundsTab extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      availableFundList: [],
      selected: []

    };
    this.fetchData();
    this.onChange = this.onChange.bind(this);
  }


  fetchData() {

    api.getFundList()
      .then(data => {
        this.setState({ availableFundList: data });
      }).catch(function (error) {
        // Acquire token interactive failure
        console.log(error);
      });
    api.getUserFund(this.props.id)
      .then(data => {
        this.setState({ selected: data.map((item) => { return item.fundName.toString() }) });
      }).catch(function (error) {
        // Acquire token interactive failure
        console.log(error);
      });
  }
  onChange(selected, selection) {
    if (selected.length > 0 && selection.length > 0) {
      for (let item of selection) {
        if (selected.includes(item)) {
          api.addUserFund(this.props.id, item)
            .then((data) => {
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    }

    if (selected.length >= 0 && selection.length > 0) {
      for (let item of selection) {
        if (!selected.includes(item)) {
          api.removeUserFund(this.props.id, item)
            .then((data) => {
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    }

    if (selected.length > 0 && selection.length === 0) {
      for (let item of selected) {
        api.addUserFund(this.props.id, item)
          .then((data) => {
          })
          .catch((error) => {
            console.log(error)
          })
      }
    }


    this.setState({ selected });
  }


  render() {
    const options = this.state.availableFundList.map((item) => { return { value: item.fundName, label: item.fundName } })
    const { selected } = this.state;

    return (
      <div>
        <div className="list-sites-flex">
          <div className="list-sites"> List of Available Funds </div>
          <div className="list-sites mr-sites"> User’s Funds </div>
        </div>
        <DualListBox
          options={options}
          selected={selected}
          onChange={this.onChange}
          className="edit-user-btn"
          icons={{
            moveLeft: <Icon className="long arrow alternate left" ></Icon>,
            moveRight: <Icon className="long arrow alternate right" ></Icon>,
            // moveAllRight: <span>Add All</span>,

          }}
        />
      </div>
    );
  }

}
export default UserFundsTab